import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material'; // Import Box and Typography from MUI
import LoadingIcon from '../icons/LoadingIcon'; // Assuming this path is correct for your LoadingIcon component

const steps = [
  'AI Agent understanding your query',
  'Checking your permissions',
  'Getting your data',
  'Checking your data',
  'Final response coming up',
];

const LoadingSequence = () => {
  const [currentStep, setCurrentStep] = useState(0);

  const runSequence = (index) => {
    setCurrentStep(index);

    if (index < steps.length - 1) {
      setTimeout(() => runSequence(index + 1), 2000);
    }
  };

  useEffect(() => {
    runSequence(0);
  }, []);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 2, // Equivalent to Tailwind gap-2 (16px, assuming MUI default spacing of 8px)
          fontSize: '1rem', // Equivalent to Tailwind text-base (16px)
          padding: 2.5, // Equivalent to Tailwind p-5 (20px)
          backgroundColor: '#F6F6F6',
          borderRadius: '8px', // Equivalent to Tailwind rounded-lg
          marginBottom: 0.5, // Equivalent to Tailwind mb-1 (4px)
          // display: 'inline-flex', // Use 'inline-flex' to maintain inline-block behavior with flex
          width: '350px',
          alignItems: 'center', // Align items vertically in the center
        }}
      >
        <Typography variant="body1">{steps[currentStep]}</Typography>
        <Box sx={{ width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {/* Equivalent to Tailwind w-8 (32px), added height, flex alignment for better icon centering */}
          <LoadingIcon />
        </Box>
      </Box>
    </Box>
  );
};

export default LoadingSequence;
